import React, { Component } from 'react';
import {
  Box,
  Breadcrumbs,
  Typography,
  Link,
  TextField,
  InputAdornment,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Avatar,
  Stack,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  Tooltip,
  CircularProgress,
  TablePagination,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from '@mui/material';
import { apiUrl } from '../../comp/ApiUrl'; // Certifique-se de que o caminho está correto
import {
  Search as SearchIcon,
  Add as AddIcon,
  ContentCopy as CopyIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  UnfoldMore as UnfoldMoreIcon,
  ListAlt as ListAltIcon,
  Refresh as RefreshIcon,
  ExpandMore as ExpandMoreIcon,
  CheckCircleOutline as CheckIcon,
  Block as BlockIcon,
} from '@mui/icons-material';

// URL base da sua API
const API_BASE_URL = apiUrl;

class ComplementosPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Dados principais (Grupo de Complementos com seus respectivos Itens)
      complementos: [],
      loading: true,

      // Filtros e Paginação
      searchTerm: '',
      page: 0,
      rowsPerPage: 10,

      // Modal Principal (Grupo de Complemento + Lista de Itens)
      openModal: false,
      editingGroup: null,
      formData: {
        nome: '', // Ex: "Escolha o Molho", "Adicionais de Hambúrguer"
        obrigatorio: false,
        qtdMinima: 0,
        qtdMaxima: 1,
        ativo: true,
        itens: [], // Lista de opções: [{ id, nome, preco, maxQtdItem, ativo }]
      },

      // Diálogo de Exclusão
      openDeleteDialog: false,
      groupToDelete: null,

      // Snackbar Feedback
      snackbar: {
        open: false,
        message: '',
        severity: 'success',
      },
    };
  }

  componentDidMount() {
    this.fetchComplementos();
  }

  // ==========================================
  // Requisições API (HTTP)
  // ==========================================

  fetchComplementos = async () => {
    this.setState({ loading: true });
    try {
      const response = await fetch(API_BASE_URL + '/complementos', {

        credentials: 'include', // Inclui cookies para autenticação, se necessário
      });
      if (!response.ok) throw new Error('Erro ao carregar complementos');
      const data = await response.json();
      this.setState({ complementos: data, loading: false });
    } catch (error) {
      console.error(error);
      // Mock inicial de fallback para demonstração
      this.setState({
        complementos: [
          {
            id: 1,
            nome: 'Ponto da Carne',
            obrigatorio: true,
            qtdMinima: 1,
            qtdMaxima: 1,
            ativo: true,
            itens: [
              { id: 101, nome: 'Bem Passado', preco: 0.0, maxQtdItem: 1, ativo: true },
              { id: 102, nome: 'Ao Ponto', preco: 0.0, maxQtdItem: 1, ativo: true },
              { id: 103, nome: 'Mal Passado', preco: 0.0, maxQtdItem: 1, ativo: true },
            ],
          },
          {
            id: 2,
            nome: 'Adicionais do Lanche',
            obrigatorio: false,
            qtdMinima: 0,
            qtdMaxima: 4,
            ativo: true,
            itens: [
              { id: 201, nome: 'Bacon Extra', preco: 4.5, maxQtdItem: 2, ativo: true },
              { id: 202, nome: 'Queijo Cheddar', preco: 3.5, maxQtdItem: 2, ativo: true },
              { id: 203, nome: 'Ovo Frito', preco: 2.0, maxQtdItem: 1, ativo: false },
            ],
          },
        ],
        loading: false,
      });
      this.showSnackbar('Carregado dados de demonstração (API offline)', 'info');
    }
  };

  handleSaveComplemento = async () => {
    const { editingGroup, formData, complementos } = this.state;

    if (!formData.nome.trim()) {
      this.showSnackbar('O nome do grupo de complemento é obrigatório.', 'warning');
      return;
    }

    if (formData.itens.length === 0) {
      this.showSnackbar('Cadastre pelo menos 1 item para este complemento.', 'warning');
      return;
    }

    const payload = {
      ...formData,
      qtdMinima: parseInt(formData.qtdMinima, 10) || 0,
      qtdMaxima: Math.max(1, parseInt(formData.qtdMaxima, 10) || 1),
      itens: formData.itens.map((item) => ({
        ...item,
        preco: parseFloat(item.preco) || 0,
        maxQtdItem: parseInt(item.maxQtdItem, 10) || 1,
      })),
    };

    try {
      let response;
      if (editingGroup) {
        response = await fetch(`${API_BASE_URL}/complementos/${editingGroup.id}`, {
          credentials: 'include', // Inclui cookies para autenticação, se necessário
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
      } else {
        response = await fetch(`${API_BASE_URL}/complementos`, {
          credentials: 'include', // Inclui cookies para autenticação, se necessário
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
      }

      if (!response.ok) throw new Error('Erro ao salvar complemento');

      this.showSnackbar(
        editingGroup ? 'Complemento atualizado!' : 'Complemento criado com sucesso!',
        'success'
      );
      this.handleCloseModal();
      this.fetchComplementos();
    } catch (error) {
      console.error(error);
      // Atualização otimista local
      if (editingGroup) {
        const updatedList = complementos.map((g) =>
          g.id === editingGroup.id ? { ...g, ...payload } : g
        );
        this.setState({ complementos: updatedList });
      } else {
        const newGroup = { id: Date.now(), ...payload };
        this.setState({ complementos: [...complementos, newGroup] });
      }

      this.showSnackbar('Salvo localmente (Modo offline)', 'success');
      this.handleCloseModal();
    }
  };

  handleToggleGroupStatus = async (group) => {
    const updatedStatus = !group.ativo;

    this.setState((prevState) => ({
      complementos: prevState.complementos.map((g) =>
        g.id === group.id ? { ...g, ativo: updatedStatus } : g
      ),
    }));

    try {
      await fetch(`${API_BASE_URL}/complementos/${group.id}/status`, {
        credentials: 'include',
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ativo: updatedStatus }),
      });
      this.showSnackbar(`Status de "${group.nome}" atualizado!`, 'success');
    } catch (error) {
      this.showSnackbar('Status alterado na interface (API offline)', 'info');
    }
  };

  handleConfirmDelete = async () => {
    const { groupToDelete, complementos } = this.state;
    if (!groupToDelete) return;

    try {
      const response = await fetch(`${API_BASE_URL}/complementos/${groupToDelete.id}`, {
        credentials: 'include',
        method: 'DELETE',
      });
      if (!response.ok) throw new Error('Erro ao deletar complemento');

      this.showSnackbar('Grupo de complemento excluído!', 'success');
      this.fetchComplementos();
    } catch (error) {
      this.setState({
        complementos: complementos.filter((g) => g.id !== groupToDelete.id),
      });
      this.showSnackbar('Item removido da lista!', 'success');
    } finally {
      this.setState({ openDeleteDialog: false, groupToDelete: null });
    }
  };

  handleDuplicateGroup = (group) => {
    const duplicated = {
      nome: `${group.nome} (Cópia)`,
      obrigatorio: group.obrigatorio,
      qtdMinima: group.qtdMinima,
      qtdMaxima: group.qtdMaxima,
      ativo: group.ativo,
      itens: group.itens.map((i) => ({ ...i, id: Date.now() + Math.random() })),
    };

    this.setState({
      editingGroup: null,
      formData: duplicated,
      openModal: true,
    });
  };

  // ==========================================
  // Gestão Dinâmica dos Itens
  // ==========================================

  handleAddItem = () => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        itens: [
          ...prevState.formData.itens,
          { id: Date.now(), nome: '', preco: 0, maxQtdItem: 1, ativo: true },
        ],
      },
    }));
  };

  handleRemoveItem = (index) => {
    this.setState((prevState) => {
      const newItens = [...prevState.formData.itens];
      newItens.splice(index, 1);
      return {
        formData: { ...prevState.formData, itens: newItens },
      };
    });
  };

  handleItemChange = (index, field, value) => {
    this.setState((prevState) => {
      const newItens = [...prevState.formData.itens];
      newItens[index] = { ...newItens[index], [field]: value };
      return {
        formData: { ...prevState.formData, itens: newItens },
      };
    });
  };

  // ==========================================
  // Modal e Modificadores de UI
  // ==========================================

  handleOpenModal = (group = null) => {
    if (group) {
      this.setState({
        editingGroup: group,
        formData: {
          nome: group.nome || '',
          obrigatorio: group.obrigatorio ?? false,
          qtdMinima: group.qtdMinima ?? 0,
          qtdMaxima: group.qtdMaxima ?? 1,
          ativo: group.ativo ?? true,
          itens: group.itens ? JSON.parse(JSON.stringify(group.itens)) : [],
        },
        openModal: true,
      });
    } else {
      this.setState({
        editingGroup: null,
        formData: {
          nome: '',
          obrigatorio: false,
          qtdMinima: 0,
          qtdMaxima: 1,
          ativo: true,
          itens: [{ id: Date.now(), nome: '', preco: 0, maxQtdItem: 1, ativo: true }],
        },
        openModal: true,
      });
    }
  };

  handleCloseModal = () => {
    this.setState({ openModal: false, editingGroup: null });
  };

  showSnackbar = (message, severity = 'success') => {
    this.setState({ snackbar: { open: true, message, severity } });
  };

  handleCloseSnackbar = () => {
    this.setState((prevState) => ({
      snackbar: { ...prevState.snackbar, open: false },
    }));
  };

  render() {
    const {
      complementos,
      loading,
      searchTerm,
      page,
      rowsPerPage,
      openModal,
      editingGroup,
      formData,
      openDeleteDialog,
      groupToDelete,
      snackbar,
    } = this.state;

    // Filtro por nome de grupo ou por itens contidos nele
    const filtered = complementos.filter(
      (g) =>
        g.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
        g.itens.some((i) => i.nome.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const paginated = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
      <Box sx={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
        {/* Breadcrumbs */}
        <Breadcrumbs separator="/" aria-label="breadcrumb" sx={{ fontSize: 13, mb: 1.5 }}>
          <Link underline="hover" color="text.secondary" href="#">
            Início
          </Link>
          <Link underline="hover" color="text.secondary" href="#">
            Cardápio
          </Link>
          <Typography color="text.primary" sx={{ fontSize: 13, fontWeight: 500 }}>
            Complementos
          </Typography>
        </Breadcrumbs>

        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar sx={{ bgcolor: '#e8e5f3', color: '#7042a4', width: 42, height: 42 }}>
              <ListAltIcon />
            </Avatar>
            <Box>
              <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', color: '#1a1a1a' }}>
                Complementos do Cardápio
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Gerencie os grupos de adicionais, opções de escolha, preços e regras de quantidade.
              </Typography>
            </Box>
          </Box>

          <Tooltip title="Atualizar dados">
            <IconButton onClick={this.fetchComplementos} sx={{ bgcolor: '#fff', border: '1px solid #ddd' }}>
              <RefreshIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>

        {/* Filter Bar */}
        <Paper elevation={0} sx={{ p: 2, mb: 3, borderRadius: 2, display: 'flex', gap: 2, border: '1px solid #e0e0e0' }}>
          <TextField
            placeholder="Pesquisar complementos ou itens..."
            size="small"
            value={searchTerm}
            onChange={(e) => this.setState({ searchTerm: e.target.value, page: 0 })}
            sx={{ flexGrow: 1, '& .MuiOutlinedInput-root': { borderRadius: 2, backgroundColor: '#fafafa' } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#aaa' }} />
                </InputAdornment>
              ),
            }}
          />

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => this.handleOpenModal(null)}
            sx={{
              backgroundColor: '#7042a4',
              textTransform: 'none',
              borderRadius: 2,
              px: 3,
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': { backgroundColor: '#5c3589' },
            }}
          >
            Novo Complemento
          </Button>
        </Paper>

        {/* Tabela de Grupos com Sanfona para exibir os Itens */}
        <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 2, border: '1px solid #e0e0e0' }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
              <CircularProgress sx={{ color: '#7042a4' }} />
            </Box>
          ) : (
            <>
              <Table sx={{ minWidth: 650 }}>
                <TableHead sx={{ backgroundColor: '#f4f4f7' }}>
                  <TableRow>
                    <TableCell style={{ width: 40 }} />
                    <TableCell sx={{ fontWeight: 'bold', color: '#555', fontSize: 12 }}>GRUPO / COMPLEMENTO</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#555', fontSize: 12 }}>OBRIGATÓRIO</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#555', fontSize: 12 }}>SELEÇÃO (MIN / MÁX)</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#555', fontSize: 12 }}>QTD. ITENS</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#555', fontSize: 12 }}>STATUS</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 'bold', color: '#555', fontSize: 12 }}>AÇÕES</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {paginated.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center" sx={{ py: 4, color: '#888' }}>
                        Nenhum complemento cadastrado.
                      </TableCell>
                    </TableRow>
                  ) : (
                    paginated.map((group) => (
                      <React.Fragment key={group.id}>
                        <TableRow hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell padding="none" align="center">
                            <UnfoldMoreIcon sx={{ color: '#ccc', cursor: 'grab', fontSize: 18 }} />
                          </TableCell>

                          <TableCell sx={{ fontWeight: 600, color: '#222' }}>
                            {group.nome}
                          </TableCell>

                          <TableCell>
                            <Chip
                              label={group.obrigatorio ? 'Sim' : 'Não'}
                              size="small"
                              sx={{
                                backgroundColor: group.obrigatorio ? '#fff3cd' : '#e2e3e5',
                                color: group.obrigatorio ? '#856404' : '#383d41',
                                fontWeight: 600,
                                fontSize: 11,
                              }}
                            />
                          </TableCell>

                          <TableCell sx={{ color: '#555', fontSize: 13 }}>
                            Min: <strong>{group.qtdMinima}</strong> | Máx: <strong>{group.qtdMaxima}</strong>
                          </TableCell>

                          <TableCell sx={{ color: '#555' }}>
                            {group.itens?.length || 0} opções
                          </TableCell>

                          <TableCell>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <Switch
                                size="small"
                                checked={Boolean(group.ativo)}
                                onChange={() => this.handleToggleGroupStatus(group)}
                                color="secondary"
                              />
                              <Typography variant="caption" sx={{ color: group.ativo ? '#155724' : '#721c24', fontWeight: 600 }}>
                                {group.ativo ? 'Ativo' : 'Inativo'}
                              </Typography>
                            </Stack>
                          </TableCell>

                          <TableCell align="right">
                            <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                              <Tooltip title="Duplicar">
                                <IconButton size="small" onClick={() => this.handleDuplicateGroup(group)}>
                                  <CopyIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Editar">
                                <IconButton size="small" onClick={() => this.handleOpenModal(group)} sx={{ color: '#7042a4' }}>
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Excluir">
                                <IconButton
                                  size="small"
                                  onClick={() => this.setState({ openDeleteDialog: true, groupToDelete: group })}
                                  sx={{ color: '#d32f2f' }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Stack>
                          </TableCell>
                        </TableRow>

                        {/* Visualização Expandida dos Itens pertencentes ao Grupo */}
                        <TableRow sx={{ backgroundColor: '#fafafa' }}>
                          <TableCell colSpan={7} sx={{ py: 1, px: 3 }}>
                            <Accordion elevation={0} sx={{ backgroundColor: 'transparent', '&:before': { display: 'none' } }}>
                              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 0, minHeight: 36 }}>
                                <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#7042a4' }}>
                                  VER OPÇÕES / ITENS DESTE COMPLEMENTO ({group.itens?.length || 0})
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails sx={{ px: 0, pt: 0 }}>
                                <Grid container spacing={1}>
                                  {group.itens?.map((item) => (
                                    <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={item.id}>
                                      <Paper
                                        variant="outlined"
                                        sx={{
                                          p: 1.5,
                                          borderRadius: 1.5,
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                          backgroundColor: item.ativo ? '#fff' : '#f0f0f0',
                                        }}
                                      >
                                        <Box>
                                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                            {item.nome}
                                          </Typography>
                                          <Typography variant="caption" color="text.secondary">
                                            Preço: +{Number(item.preco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} | Máx/Pedido: {item.maxQtdItem}
                                          </Typography>
                                        </Box>
                                        {item.ativo ? (
                                          <Chip icon={<CheckIcon />} label="Disponível" size="small" color="success" variant="outlined" sx={{ height: 20, fontSize: 10 }} />
                                        ) : (
                                          <Chip icon={<BlockIcon />} label="Esgotado" size="small" color="error" variant="outlined" sx={{ height: 20, fontSize: 10 }} />
                                        )}
                                      </Paper>
                                    </Grid>
                                  ))}
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))
                  )}
                </TableBody>
              </Table>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filtered.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(e, p) => this.setState({ page: p })}
                onRowsPerPageChange={(e) => this.setState({ rowsPerPage: parseInt(e.target.value, 10), page: 0 })}
                labelRowsPerPage="Itens por página:"
              />
            </>
          )}
        </TableContainer>

        {/* Modal de Cadastro/Edição de Complemento com Lista de Itens */}
        <Dialog open={openModal} onClose={this.handleCloseModal} maxWidth="md" fullWidth>
          <DialogTitle sx={{ fontWeight: 'bold', color: '#7042a4' }}>
            {editingGroup ? 'Editar Grupo de Complementos' : 'Novo Grupo de Complementos'}
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              {/* Configurações do Grupo */}
              <Grid item size={{ xs: 12, sm: 6 }}>
                <TextField
                  label="Nome do Complemento (Ex: Ponto da Carne, Adicionais)"
                  fullWidth
                  required
                  size="small"
                  value={formData.nome}
                  onChange={(e) => this.setState({ formData: { ...formData, nome: e.target.value } })}
                />
              </Grid>

              <Grid item size={{ xs: 6, sm: 3 }}>
                <TextField
                  label="Qtd Mínima"
                  type="number"
                  fullWidth
                  size="small"
                  value={formData.qtdMinima}
                  onChange={(e) => this.setState({ formData: { ...formData, qtdMinima: e.target.value } })}
                />
              </Grid>

              <Grid item size={{ xs: 6, sm: 3 }}>
                <TextField
                  label="Qtd Máxima"
                  type="number"
                  fullWidth
                  size="small"
                  value={formData.qtdMaxima}
                  onChange={(e) => this.setState({ formData: { ...formData, qtdMaxima: e.target.value } })}
                />
              </Grid>

              <Grid item size={{ xs: 12, sm: 6 }}>
                <Stack direction="row" spacing={2} alignItems="center" sx={{ height: '100%' }}>
                  <Switch
                    checked={formData.obrigatorio}
                    onChange={(e) => this.setState({ formData: { ...formData, obrigatorio: e.target.checked } })}
                    color="secondary"
                  />
                  <Typography variant="body2">
                    {formData.obrigatorio ? 'Seleção Obrigatória' : 'Seleção Opcional'}
                  </Typography>
                </Stack>
              </Grid>

              <Grid item size={{ xs: 12, sm: 6 }}>
                <Stack direction="row" spacing={2} alignItems="center" sx={{ height: '100%' }}>
                  <Switch
                    checked={formData.ativo}
                    onChange={(e) => this.setState({ formData: { ...formData, ativo: e.target.checked } })}
                    color="secondary"
                  />
                  <Typography variant="body2">
                    {formData.ativo ? 'Grupo Ativo no Cardápio' : 'Grupo Pausado / Inativo'}
                  </Typography>
                </Stack>
              </Grid>

              <Grid item size={{ xs: 12 }}>
                <Divider sx={{ my: 1 }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#333' }}>
                    ITENS / OPÇÕES DESTE COMPLEMENTO
                  </Typography>
                  <Button
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={this.handleAddItem}
                    sx={{ color: '#7042a4', textTransform: 'none', fontWeight: 600 }}
                  >
                    Adicionar Item
                  </Button>
                </Box>

                {/* Lista Dinâmica de Opções de Itens */}
                {formData.itens.map((item, index) => (
                  <Paper key={item.id || index} variant="outlined" sx={{ p: 1.5, mb: 1.5, borderRadius: 2 }}>
                    <Grid container spacing={1.5} alignItems="center">
                      <Grid item size={{ xs: 12, sm: 4 }}>
                        <TextField
                          label="Nome da Opção (Ex: Bacon, Molho)"
                          fullWidth
                          size="small"
                          value={item.nome}
                          onChange={(e) => this.handleItemChange(index, 'nome', e.target.value)}
                        />
                      </Grid>

                      <Grid item size={{ xs: 6, sm: 3 }}>
                        <TextField
                          label="Preço Adicional"
                          type="number"
                          fullWidth
                          size="small"
                          value={item.preco}
                          onChange={(e) => this.handleItemChange(index, 'preco', e.target.value)}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                          }}
                        />
                      </Grid>

                      <Grid item size={{ xs: 6, sm: 3 }}>
                        <TextField
                          label="Máx/Cliente"
                          type="number"
                          fullWidth
                          size="small"
                          value={item.maxQtdItem}
                          onChange={(e) => this.handleItemChange(index, 'maxQtdItem', e.target.value)}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 2 }} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Tooltip title={item.ativo ? 'Em estoque' : 'Esgotado'}>
                          <Switch
                            size="small"
                            checked={item.ativo}
                            onChange={(e) => this.handleItemChange(index, 'ativo', e.target.checked)}
                          />
                        </Tooltip>
                        <IconButton size="small" onClick={() => this.handleRemoveItem(index)} sx={{ color: '#d32f2f', ml: 1 }}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Paper>
                ))}
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={this.handleCloseModal} sx={{ color: '#666', textTransform: 'none' }}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={this.handleSaveComplemento}
              sx={{ backgroundColor: '#7042a4', textTransform: 'none', px: 3, '&:hover': { backgroundColor: '#5c3589' } }}
            >
              Salvar Complemento
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal de Exclusão */}
        <Dialog open={openDeleteDialog} onClose={() => this.setState({ openDeleteDialog: false })}>
          <DialogTitle>Excluir Complemento</DialogTitle>
          <DialogContent>
            <Typography>
              Tem certeza que deseja excluir o grupo de complementos <strong>"{groupToDelete?.nome}"</strong>? Isso desvinculará todas as opções existentes.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => this.setState({ openDeleteDialog: false })} sx={{ textTransform: 'none' }}>
              Cancelar
            </Button>
            <Button variant="contained" color="error" onClick={this.handleConfirmDelete} sx={{ textTransform: 'none' }}>
              Excluir
            </Button>
          </DialogActions>
        </Dialog>

        {/* Feedback Snackbar */}
        <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={this.handleCloseSnackbar}>
          <Alert onClose={this.handleCloseSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

export default ComplementosPage;